import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Creates a stock log entry
 * @param {Object} logData - The stock log data
 * @param {string} logData.itemId - ID of the item
 * @param {string} logData.itemName - Name of the item
 * @param {string} logData.itemType - Type of the item (e.g., 'Accessory', 'CPAP', etc.)
 * @param {number} logData.quantity - Quantity changed (positive for add, negative for sell/adjust)
 * @param {number} logData.stockBefore - Stock quantity before the change
 * @param {number} logData.stockAfter - Stock quantity after the change
 * @param {string} logData.type - Type of movement: 'add', 'return', 'adjust', 'sell', 'withdraw'
 * @param {string} logData.notes - Notes about the movement
 * @param {string} logData.createdBy - Who made the change
 */
export const createStockLog = async (logData) => {
  try {
    const stockLogEntry = {
      itemId: logData.itemId,
      itemName: logData.itemName,
      itemType: logData.itemType,
      quantity: logData.quantity,
      stockBefore: logData.stockBefore,
      stockAfter: logData.stockAfter,
      type: logData.type,
      notes: logData.notes || '',
      createdBy: logData.createdBy,
      createdAt: new Date(),
      date: new Date()
    };

    const docRef = await addDoc(collection(db, "stockLogs"), stockLogEntry);
    console.log("Stock log created with ID: ", docRef.id);
    
    return docRef.id;
  } catch (error) {
    console.error("Error creating stock log: ", error);
    throw error;
  }
};

/**
 * Creates multiple stock log entries in batch
 * @param {Array} logsData - Array of stock log data objects
 */
export const createMultipleStockLogs = async (logsData) => {
  try {
    const promises = logsData.map(logData => createStockLog(logData));
    await Promise.all(promises);
    console.log(`Created ${logsData.length} stock log entries`);
  } catch (error) {
    console.error("Error creating multiple stock logs: ", error);
    throw error;
  }
};